export default __webpack_public_path__ + "static/media/amaz.3e3e6b8f.png";